import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Compartilha o total de itens pendentes de curadoria entre a fila
 * (CurationQueueComponent) e o badge da aba "Curadoria" no AdminShellComponent.
 * A fila publica o número sempre que o recalcula (carga, curar, descartar) e o
 * shell apenas observa — mantendo o badge sincronizado sem refetch.
 */
@Injectable({ providedIn: 'root' })
export class CurationCountsService {
  private readonly pendingSubject = new BehaviorSubject<number | undefined>(undefined);
  readonly pending$: Observable<number | undefined> = this.pendingSubject.asObservable();

  /** Valor atual de pendentes (snapshot síncrono do BehaviorSubject). */
  get pending(): number | undefined {
    return this.pendingSubject.value;
  }

  setPending(count: number): void {
    this.pendingSubject.next(count);
  }
}
